export function sendMessage(container, message) {
    if(container && container.contentWindow)     
        container.contentWindow.postMessage(JSON.stringify(message), '*');
}

export async function createMpAvatar(faceImageBase64, apiHost) {    
    // Create body object
    const body = {
        FaceImageBase64:faceImageBase64.replace('data:image/jpeg;base64,',''),
    };

    // Initialize the API URL
    const api = apiHost + '/avatar/create';
    // return the response promise
    const response = await fetch(api, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    
    const avatarData = await response.text()    
    return avatarData;
}